<script setup lang="ts">
  interface Props {
    note?: string;
    isSub?: boolean;
  }
  withDefaults(defineProps<Props>(), {
    note: "",
    isSub: false,
  });

  // レスポンシブ対応
  const isSp = isSpDisplayRef();
  const titleFontSize = computed<string>(() => (isSp.value ? "14px" : "20px"));
  const textFontSize = computed<string>(() => (isSp.value ? "14px" : "16px"));
  const cardWidth = computed<string>(() => (isSp.value ? "100%" : "80%"));
  const contentsWidth = computed<string>(() => (isSp.value ? "95%" : "60%"));
</script>

<template>
  <v-container class="container">
    <div color="monochrome-04" class="mx-auto px-1 my-2 my-sm-6 item">
      <v-sheet color="monochrome-04" class="w-100 rounded">
        <div class="px-2 px-sm-6 pt-2 pt-sm-4 w-100">
          <div class="title-text">
            <slot name="header"></slot>
          </div>
        </div>
        <v-divider class="ma-2 ma-sm-4"></v-divider>
        <div class="px-2 px-sm-6 pb-4 pb-sm-6 w-100">
          <slot></slot>
        </div>
      </v-sheet>
    </div>
  </v-container>
</template>

<style lang="scss" scoped>
  @media (min-width: 1280px) {
    .container {
      max-width: 1400px !important;
    }
  }

  @media (max-width: 960px) {
    .container {
      max-width: 900px !important;
    }
  }
  .item {
    width: v-bind(cardWidth);
    > div {
      width: v-bind(contentsWidth);
    }
    .item-heading {
      font-size: 22px;
      font-style: normal;
      font-weight: 700;
    }
  }
  .item-text {
    font-size: v-bind(textFontSize);
    font-weight: 400;
    font-style: normal;
    line-height: 1.8em;
  }
  .title-text {
    font-size: v-bind(titleFontSize);
    font-weight: 700;
    line-height: 1.8em;
    letter-spacing: 0.06em;
    text-align: left;
  }
</style>
